(function ($, XTT) {
	'use strict';

	XTT.carousel = {
		_autoload: [
			'carousel'
		],

		carousel: function() {

			var $gallerySelector = $('.gallery');
			var $thumbnailsSelector = $('.thumbnail-gallery');

			if($gallerySelector.length > 0) {
			 	$gallerySelector.slick({
			 		accessibility: false,
			 		adaptiveHeight: true,
			 		dots: false,
			 		prevArrow: '<button type="button" class="slick-prev ion-ios-arrow-left"></button>',
			 		nextArrow: '<button type="button" class="slick-next ion-ios-arrow-right"></button>',
			 		asNavFor: $thumbnailsSelector.length ? '.thumbnail-gallery' : undefined,
			 		responsive: [
				    {
				      breakpoint: 769,
				      settings: {
				        dots: true
				      }
				    }
				  ]
			 	});
		 	}

		 	if($thumbnailsSelector.length > 0) {
			 	$thumbnailsSelector.slick({
			 		accessibility: false,
			 		adaptiveHeight: true,
			 		dots: false,
			 		prevArrow: '<button type="button" class="slick-prev ion-ios-arrow-left"></button>',
			 		nextArrow: '<button type="button" class="slick-next ion-ios-arrow-right"></button>',
			 		asNavFor: '.gallery',
			 		slidesToShow: 4,
	  			slidesToScroll: 1,
				  focusOnSelect: true
			 	});
		 	}
		}

	};

})
(jQuery, XTT);